import BaseApi from './baseApi';
import IListPalletType from '../models/IListPalletType';
import IAuthentication from '../models/IAuthentication';
export default class ListPalletTypesApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListPalleTypes() : Promise<IListPalletType[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listPalletTypes: IListPalletType[] = [];
            listPalletTypes = response.data as IListPalletType[];
            return listPalletTypes;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListPalletType(listPalletType: IListPalletType) : Promise<string> {
        const json = this.getJsonSave(listPalletType);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListPalletType(listPalletType: IListPalletType) : Promise<boolean> {
        const json = this.getJsonUpdate(listPalletType);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListPalletType(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_PALLET_TYPE_IN_USE",
            "parameters": [{
                "Item1": "PalletTypeId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListPalletTypes",
                "Item2": "id"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "notBillable"
            }],
            "tables": [{
                "Item1": "ListPalletTypes"
            }],
            "conditions": [{
                "Item1": "ListPalletTypes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListPalletTypes.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListPalletTypes",
            "conditions": [{
                "Item1": "ListPalletTypes",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listPalletType: IListPalletType) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listPalletType.name
            }, {
                "Item1": "notBillable",
                "Item2": listPalletType.notBillable
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListPalletTypes"
        };
        return json;
    }

    private getJsonUpdate(listPalletType: IListPalletType) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listPalletType.name
            }, {
                "Item1": "notBillable",
                "Item2": listPalletType.notBillable
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListPalletTypes",
            "keyvalue": listPalletType.id
        };
        return json;
    }
}
